// Client-side brand metadata used for fast first-paint rendering.
// The canonical copy lives on the backend and is fetched to stay in sync.
export const BRANDS = {
  qcm: {
    slug: "qcm",
    name: "Queen City Metal Recycling",
    short_name: "Queen City Metal",
    tagline: "Sustainable Waste Management Made Easy",
    city: "Charlotte",
    state: "NC",
    address: "601 West 24th Street, Charlotte, NC 28206",
    phone: "704-332-9752",
    phone_alt: "704-342-5388",
    email: "mickey@qcrecycling.com",
    map_url:
      "https://maps.google.com/?q=601+West+24th+Street+Charlotte+NC+28206",
    hours: [
      { day: "Mon", hours: "8:00 AM – 4:15 PM" },
      { day: "Tue", hours: "8:00 AM – 4:15 PM" },
      { day: "Wed", hours: "8:00 AM – 4:15 PM" },
      { day: "Thu", hours: "8:00 AM – 4:15 PM" },
      { day: "Fri", hours: "8:00 AM – 4:15 PM" },
      { day: "Sat", hours: "8:00 AM – 12:45 PM" },
      { day: "Sun", hours: "Closed" },
    ],
    established: "15+ Years",
    sister_slug: "dales",
    website: "queencitymetal.com",
    path: "/",
  },
  dales: {
    slug: "dales",
    name: "Dale's Recycling",
    short_name: "Dale's Recycling",
    tagline:
      "It's More Than Just Scrap — Conserving Resources Through Recycling",
    city: "Hudson",
    state: "NC",
    address: "3457 Hickory Blvd, Hudson, NC 28638",
    phone: "828-396-7619",
    phone_alt: "704-332-9752",
    email: "mickey@qcrecycling.com",
    map_url: "https://maps.google.com/?q=3457+Hickory+Blvd+Hudson+NC+28638",
    hours: [
      { day: "Mon", hours: "9:00 AM – 4:00 PM" },
      { day: "Tue", hours: "9:00 AM – 4:00 PM" },
      { day: "Wed", hours: "9:00 AM – 4:00 PM" },
      { day: "Thu", hours: "9:00 AM – 4:00 PM" },
      { day: "Fri", hours: "9:00 AM – 4:00 PM" },
      { day: "Sat", hours: "8:00 AM – 12:00 PM" },
      { day: "Sun", hours: "Closed" },
    ],
    established: "15+ Years",
    sister_slug: "qcm",
    website: "dalesrecycling.com",
    path: "/dales",
  },
};

export const brandPath = (slug) => (slug === "dales" ? "/dales" : "/");

// Resolves the correct URL to navigate to a given brand from the current page.
// In production we have separate domains, so we cross-link to the sister domain.
// In preview / shared deployment we just swap routes.
export const brandUrl = (slug) => {
  if (typeof window === "undefined") return brandPath(slug);
  const host = window.location.hostname.toLowerCase();
  const onProdDomain =
    host.includes("queencitymetal") || host.includes("dalesrecycling");
  if (onProdDomain) {
    return slug === "dales"
      ? "https://dalesrecycling.com/"
      : "https://queencitymetal.com/";
  }
  return brandPath(slug);
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/36397858/pexels-photo-36397858.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  team:
    "https://customer-assets.emergentagent.com/job_integrated-yards/artifacts/8lm27ial_profile%20pic%20tucker.jpg",
  community:
    "https://images.unsplash.com/photo-1673985402265-46c4d2e53982?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  yard:
    "https://images.unsplash.com/photo-1770068511830-a6cc498f4bfe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const MATERIALS = {
  ferrous: {
    title: "Ferrous Metals",
    subtitle: "Magnetic Metals",
    items: [
      "Light Iron",
      "Heavy Steel",
      "Cast Iron",
      "Industrial Scrap",
      "Cars & Trucks",
      "Farm Equipment",
      "Machinery",
      "Appliances (washers, dryers, stoves)",
      "Structural Steel",
    ],
  },
  non_ferrous: {
    title: "Non-Ferrous Metals",
    subtitle: "Higher Value · Non-Magnetic",
    items: [
      "Copper (bare bright, #1, #2)",
      "Lite Copper",
      "Insulated Copper Wire",
      "Insulated Aluminum Wire",
      "Aluminum (cans, sheet, extrusions, rims)",
      "Brass",
      "Stainless Steel",
      "Electric Motors",
      "Radiators (copper/aluminum)",
      "Batteries & Lead",
      "AC Units & Sealed Units",
      "Zinc",
    ],
  },
};

export const SERVICES = [
  {
    title: "Commercial Recycling",
    body:
      "Help your business reduce waste and lower disposal costs. We accept a wide range of recyclable materials and provide competitive rates for bulk volume.",
  },
  {
    title: "Pickup & Split Loads",
    body:
      "Convenient pickup service — we haul and process many types of metal at no additional charge. Dale's and QCM both accept split loads.",
  },
  {
    title: "Waste Reduction Consulting",
    body:
      "Custom waste-reduction programs for industrial clients. We analyze your streams and build recycling workflows that save money and cut landfill volume.",
  },
  {
    title: "Flexible Payment Terms",
    body:
      "All materials priced on an individual basis with flexible payment terms to accommodate contractors, fleets, and one-time sellers alike.",
  },
];
